import Moment from 'moment-timezone';
import { i18n } from '@/plugins/i18n';
import VitalityCriterion from '@/utils/classes/VitalityCategory/VitalityCriterion';

/**
 * Score based on whether a problem has been reported when an indicator is red.
 * If more than two consecutive values are red, there should be a problem reported between
 * two following dates :
 * - 3 days before the start of the red period
 * - 3 days after the end of the red period
 */
export default new VitalityCriterion({
  titleTr: 'VH_I_PB_WHEN_RED',
  key: 'indicatorProblemsWhenRed',
  weight: 2,

  score: ({ themes }, { start, end }) => {

    let nValues = 0;
    let redPeriodStart = null;
    let redPeriodEnd = null;
    let nConsecutiveRedValues = 0;
    let nRedPeriodWithProblem = 0;
    let nRedPeriods = 0;

    function endOfRedPeriod(indic) {
      if (nConsecutiveRedValues > 1) {
        nRedPeriods++;
        redPeriodStart.subtract(3, 'd');
        redPeriodEnd.add(3, 'd');
        if (
          indic.problems
          && indic.problems.some(pb => redPeriodStart.isBefore(pb.created)
          && redPeriodEnd.isAfter(pb.created) )
        ) {
          nRedPeriodWithProblem++;
        }
      }
      nConsecutiveRedValues = 0;
      redPeriodStart = null;
      redPeriodEnd = null;
    }

    themes.forEach((theme) => {
      theme.indicators.forEach((indic) => {
        if (indic.copyPublic === null && indic.inputValues) {
          const objIsMax = indic.objectiveIsMax === 1;
          const iDate = Moment(start);
          while (!iDate.isAfter(end)) {
            const key = iDate.format('YYYY-MM-DD');
            const v = indic.inputValues[key];
            if (v && v.value !== null) {
              nValues++;
              if ((objIsMax && v.value > indic.objectives[key]) || (!objIsMax && v.value < indic.objectives[key])) {
                // Value overruns the objective
                nConsecutiveRedValues++;
                if (nConsecutiveRedValues === 1) {
                  redPeriodStart = iDate.clone();
                }
                redPeriodEnd = iDate.clone();
              } else {
                // Value is green
                endOfRedPeriod(indic);
              }
            }
            iDate.add(1, 'd');
          }
          endOfRedPeriod(indic);
        }
      });
    });

    const noValues = nValues === 0;
    const noRedPeriods = nRedPeriods === 0;
    let score = noRedPeriods ? 100 : nRedPeriodWithProblem * 100 / nRedPeriods;
    if (noValues) {
      score = 0;
    }

    return {
      score,
      data: {
        score,
        noValues,
        noRedPeriods,
        nRedPeriodWithProblem,
        nRedPeriods,
      },
    };
  },

  text(data) {
    if (data.noValues) {
      return i18n.t('message.VH_I_NO_VALUES');
    }
    if (data.noRedPeriods) {
      return i18n.t('message.VH_I_NO_RED_PERIOD');
    }
    return i18n.t('message.VH_I_PB_WHEN_RED_TEXT', {
      score: data.score.sToFixed(0),
      nWithProblem: data.nRedPeriodWithProblem,
      nTotal: data.nRedPeriods,
    });
  },

});
